import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';
import { getStatusColours } from '../../utils';
import { quoteStatuses } from '../../utils/constants';

StatusChip.propTypes = {
  statuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  showPaymentStatus: PropTypes.bool,
};

export default function StatusChip({ statuses, showPaymentStatus = true }) {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {statuses.map((status, idx) => {
        // Skip payment status if not confirmed or if showPaymentStatus is false
        if (idx === 1 && (!showPaymentStatus || statuses[0] !== quoteStatuses.ACCEPTED)) {
          return null;
        }

        const styles = getStatusColours(status);

        return (
          <Chip
            key={idx}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: 'currentColor',
                  }}
                />
                {status}
              </Box>
            }
            size="small"
            sx={{
              height: '24px',
              fontSize: '0.75rem',
              fontWeight: 500,
              borderRadius: '4px',
              ...styles,
              '& .MuiChip-label': {
                padding: '0 8px',
              },
            }}
          />
        );
      })}
    </Box>
  );
}
